document.querySelectorAll('.sw-mobile-purchase').forEach((bar) => {
  const section = document.getElementById('MainProduct-' + bar.dataset.swSection);
  if (!section) return;
  const price = bar.querySelector('.sw-mobile-purchase__price');
  const sync = () => {
    const source = section.querySelector('.price .price-item--sale') || section.querySelector('.price .price-item--regular');
    const sale = section.querySelector('.price--on-sale');
    const regular = section.querySelector('.price .price-item--regular');
    price.textContent = (sale ? source : regular)?.textContent.trim() || '';
  };
  sync();
  new MutationObserver(sync).observe(section, { childList: true, subtree: true, characterData: true });
});